<template>
  <article
    class="bootcamp bootcamp--featured"
    :style="`background-image: url(${bootcamp.featured_background_image_url})`"
  >
    <div class="bootcamp__content">
      <div class="bootcamp__info">
        <div class="bootcamp__pass">
          <Passes :passName="learningAreaName" :size="45" />
        </div>
        <h4 class="bootcamp__title">
          <router-link
            :to="{ name: 'bootcamp', params: { id: bootcamp.id } }"
            class="bootcamp__title-link"
            >{{ bootcamp.name }}</router-link
          >
        </h4>
        <p class="bootcamp__instructors">With {{ contentInstructors }}</p>
        <p
          class="bootcamp__description"
          v-html="renderMarkdown(bootcamp.description)"
        ></p>
      </div>
      <div class="bootcamp__details">
        <p class="bootcamp__detail">
          <CalendarIcon class="bootcamp__icon" />
          {{
            formatDate({
              start: bootcamp.start_datetime,
              end: bootcamp.end_datetime,
            })
          }}
          <i
            class="bootcamp__timezone-icon material-icons info-icon"
            role="presentation"
            v-tooltip="{
              content: `Local time: ${localTimeZone}`,
              placement: 'top-center',
            }"
          >
            info_outline
          </i>
        </p>
      </div>
    </div>
    <div class="bootcamp__actions">
      <router-link
        :to="{ name: 'bootcamp', params: { id: bootcamp.id } }"
        class="bootcamp__link"
        >See Details</router-link
      >
    </div>
  </article>
</template>

<script>
import Passes from '@/components/properties/Passes.vue'
import CalendarIcon from '@/assets/icons/bootcamps/date_icon.svg'
import { localTimezone, bootcampCommons } from '@/helpers/mixins'

export default {
  name: 'FeaturedBootcamp',
  mixins: [localTimezone, bootcampCommons],
  components: {
    Passes,
    CalendarIcon: { ...CalendarIcon, name: 'CalendarIcon' },
  },
  props: {
    bootcamp: {
      type: Object,
      required: true,
    },
    formatDate: {
      type: Function,
      required: true,
    },
    renderMarkdown: {
      type: Function,
      required: true,
    },
  },
}
</script>
